// src/contexts/AuthContext.js
import React, { createContext, useEffect, useState } from 'react';
import { decodeJWTAndDecryptSub } from './Firebase';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [isAuthorized, setIsAuthorized] = useState(false);
    const [pageLoader, setPageLoader] = useState(true);
    const [alert, setAlert] = useState({ open: false, message: '', type: '' });

    useEffect(() => {
        const initializeAuth = async () => {
            const queryString = window.location.search;
            const urlParams = new URLSearchParams(queryString);
            const token = urlParams.get('jwt_token');
            const sessionToken = sessionStorage.getItem('sessionToken');

            if(window.location.pathname === "/" && localStorage.getItem("AI_UserData")){
                sessionStorage.setItem("sessionToken" , true)
                window.location.href="/Portal/index.html"
            }

            if (!token && !sessionToken) {
                setAlert({
                    open: true,
                    message: "You don't have permission to access this service",
                    type: 'danger',
                });
                setIsAuthorized(false);
            } else {
                const finalToken = token || sessionToken;
                if (sessionToken !== finalToken) {
                    sessionStorage.setItem('sessionToken', finalToken);
                    await decodeJWTAndDecryptSub(finalToken);
                }
                setIsAuthorized(true);
            }
            setPageLoader(false);
        };

        initializeAuth();
    }, []);

    const value = {
        isAuthorized,
        pageLoader,
        alert,
        setAlert,
    };

        if(pageLoader){
        return(
            <span className="Spinloader"></span>
        )
    }

    return (
        <AuthContext.Provider value={value}>
            {children}
        </AuthContext.Provider>
    );
};
